import React, { useState,forwardRef } from 'react'
import { useSpring, animated } from 'react-spring'
import * as permStorage from '../helpers/permanent-storage'
import * as firebase from '../helpers/firebase'
import './NoteInputBox.scss'

// Accepts note input and saves it.
// Saves to Localstorage onChange.
// Saves permanently to DB onBlur.
// Only note.data gets written to the db, the rest of the fields are metadata.
// Even if the user is offline, notes get "written" to Firestore when the saveNote function runs.
// Once the user gets back online, Firestore will save it to the database. Even unsaved notes show up in the notes list immediately.
const NoteInputBox = forwardRef((props,ref) => {
    const existingNote = permStorage.getCurrentNote()
    const emptyNote = {
        id: undefined,
        data: {
            text: '',
            title: '',
            color: '',
        }
    }
    const [currentNote, setCurrentNote] = useState(existingNote || emptyNote)
    const [isSaving, setIsSaving] = useState(false)
// For note expansion effect
    const [isNoteInputExpanded, setIsNoteInputExpanded] = useState(false)
    const minHeightStyle = useSpring({ minHeight: isNoteInputExpanded ? 120 + 'px' : '0px' })
    
    const user = props.user
// Store the text from the note that will be saved  
    function handleOnChange(e) {
        const updatedNote = { ...currentNote, data: { text: e.target.value } }
        if (!updatedNote.id) {
            updatedNote.id = firebase.generateDocumentId()
        }
        updatedNote.data.title = props.getTitle()
        updatedNote.data.color = getNoteColor()

        setCurrentNote(updatedNote)
        permStorage.setCurrentNote(updatedNote)
    }
/* Get the note color from the color picker */
    function getNoteColor(){
        let color = props.getNoteColor()
        return color
    }

    async function handleOnBlur() {
        props.clearTitle()

        const updatedNote = {...currentNote, data: {title: props.getTitle}}
        setCurrentNote(updatedNote)
        
        setIsNoteInputExpanded(false)

        if (currentNote.data.text && currentNote.data.text.trim().length > 0) {
            const noteToSave = { ...currentNote }

            

            clearCurrentNote()
            setIsSaving(true)

            saveNote(noteToSave)
                .then()
                .catch(e => {
                    console.log('Failed to save', e)
                })
                .finally(() => setIsSaving(false))
        }
    }

    function handleOnFocus() {
        // props.dimBg()
        setIsNoteInputExpanded(true)
    }
    
    function saveNote(note) {
        const db = firebase.getDb()

        return db.collection(`/users/${user.uid}/notes`)
                .doc(note.id)
                .set({ ...note.data, createdDatetime: firebase.clientTimestamp() }, { merge: true })
    }

    function clearCurrentNote() {
        setCurrentNote(emptyNote)
        permStorage.removeCurrentNote()
    }


    return (
        <div className="container position-relative" id="note-input-container">
            <div className="row d-flex justify-content-center">
                <div className="col-10 note-input-textarea-wrapper">
                    <textarea
                        ref = {props.refInputBox}
                        className='note-input'
                        placeholder='Enter a note...'
                        value={currentNote.data.text}
                        onChange={handleOnChange}
                        onFocus={handleOnFocus}
                        onBlur={handleOnBlur}
                        aria-multiline={true}
                        aria-label='Note input'
                    ></textarea>

                    {/* This div is hidden but is used to size the textarea. textarea grows and shrinks based on size of this div */}
                    <animated.div 
                        id='textarea-copy'
                        style={minHeightStyle}
                        // dangerouslySetInnerHTML={{__html: currentNote.data.text.replace(/\n/g, '<br />') + '<br />'}}
                        >
                    </animated.div>
                </div>
            </div>
        </div>
    )
})

export default NoteInputBox